import React from "react";
import { createRoot } from 'react-dom/client';
import "./styles/colors.scss";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AppContext } from "./Components/Context/AppContext";

const storedTheme = localStorage.getItem("archeo-theme");
document.documentElement.setAttribute(
  "data-theme",
  storedTheme === "night" ? "night" : "day"
);

const container = document.getElementById('app');
if (container) {
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <AppContext>
        <App />
      </AppContext>
    </BrowserRouter>
  );
} else {
  console.error("Target container 'app' not found in the DOM.");
}